import { FieldArray } from "formik";
import FieldRenderer from "../global/forms/FieldRenderer";
import ArrayInputProps from "../../services/models/formModels/MultiStepForm/arrayInputProps.model";
import { Fragment } from "react/jsx-runtime";
import Button from "./Button";
import { useContext } from "react";
import { OrderStepsContext } from "../../services/context/OrderStepsContext";
import CloseIcon from "../../assets/svg/CloseIcon";
import utils from "../../services/utils";
import { useLocation } from "react-router-dom";
import CustomText from "../atomic/CustomText";

function ArrayInput({
  fields,
  arrayName,
  values,
  displayWhen,
  remove,
  addMore,
  setFieldValue,
  totalFields,
  currIndex
}: ArrayInputProps): JSX.Element | null {
  const removeClinician = remove;
  const location = useLocation();

  const { dispatch } = useContext(OrderStepsContext);

  if (!!displayWhen) {
    if (!utils.displayHandler(displayWhen, values ?? {})) {
      return null;
    }
  }

  function handleRemoveClinician(remove: Function) {
    if (removeClinician?.index === 0) {
      remove(removeClinician?.index);
      setFieldValue?.("isAdditionalClinician", false, true);
      setFieldValue?.("isAttestation", false, true);
    } else {
      removeClinician?.onClick?.(dispatch, removeClinician.index);
      remove(removeClinician?.index);
    }
  }

  return (
    <Fragment>
      <div
        className={` ${location?.pathname?.includes("test-orders")
          ? "bg-sideNavGray"
          : "bg-white"
          } p-6 shadow-md rounded-md hover:border-primary border mb-6`}
      >
        <FieldArray name={arrayName}>
          {({ insert, remove, push }) => (
            <div className="w-full relative">
              <CustomText text={`Additional Clinician ${currIndex !== undefined ? currIndex + 1 : ''}`} fontWeight="font-semibold" />
              <FieldRenderer
                fields={fields.map((field) => ({
                  ...field,
                  disabled: !!removeClinician ? false : true,
                }))}
              />
              {!!removeClinician && (
                <CloseIcon
                  className="hover:cursor-pointer absolute top-0 right-0"
                  onClick={() => handleRemoveClinician(remove)}
                />
              )}
            </div>
          )}
        </FieldArray>
      </div>
      {addMore /* && totalFields && removeClinician?.index === totalFields - 1 */ && (
        <Button
          textInformation={{ text: "+ Add More", fontWeight: "font-semibold" }}
          onClick={() => {
            addMore.onClick(dispatch);
          }}
          buttonTheme="transparent"
          className="text-primary"
        />
      )}
    </Fragment>
  );
}

export default ArrayInput;
